import styled from 'styled-components';
import { white } from 'styles/Colors';

export const SnackbarWrapper = styled.div<{
  color?: string;
  styles?: { top: string; bottom: string; left: string; right: string; transform: string };
}>`
  width: 600px;
  position: absolute;
  z-index: 10015;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  background-color: ${white};
  display: flex;
  gap: 8px;
  border-left: 8px solid ${(props) => props.color};
  height: 56px;
  align-items: center;
  padding-left: 8px;
  cursor: pointer;
  bottom: ${(props) => props.styles?.bottom};
  top: ${(props) => props.styles?.top};
  left: ${(props) => props.styles?.left};
  right: ${(props) => props.styles?.right};
  transform: ${(props) => props.styles?.transform};
`;

export const Description = styled.div`
  font-size: 15px;
`;

export const StyledSpinner = styled.img`
  animation: rotating 1.5s linear infinite;

  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
